import mixpanelUtils from '@/utils/mixpanel.utils'

const setPresentation = (state, payload) => {
  if (!payload.language) {
    payload.language = 'en'
  }
  state.presentation = payload
}

const updatePresentation = (state, payload) => {
  if (!payload.language && !state.presentation.language) {
    payload.language = 'en'
  } else if (!payload.fontFamily && !state.presentation.fontFamily) {
    payload.fontFamily = 'Plus Jakarta Sans'
  }
  state.presentation = { ...state.presentation, ...payload }
}

const unsetPresentation = () => {
  mixpanelUtils.unregisterPresentationContext()
}

const setIsCreatingNewPresentation = (state, payload) => {
  state.isCreatingNewPresentation = payload
}

const setMorePresentationsLoading = (state, payload) => {
  state.loaders.morePresentationsLoading = payload
}

const setQRCodeVisible = (state, payload) => {
  state.isQRCodeVisible = payload
}

const setIsOpeningPrivateFeedback = (state, payload) => {
  state.isOpeningPrivateFeedback = payload
}

const toggleNotificationPanel = (state) => {
  state.isShowNotificationPanel = !state.isShowNotificationPanel
}

const resetNotificationUnread = (state) => {
  state.notificationUnread = 0
}

const setPresentFromBeginning = (state, payload) => {
  state.presentIsBeginning = payload
}

const addSlides = (state, payload) => {
  const { slidesToAdd, insertAfter } = payload

  const newSlides = [...state.presentation.slides]
  newSlides.splice(insertAfter + 1, 0, ...slidesToAdd)

  state.presentation.slides = newSlides
}

const setExportingType = (state, payload) => {
  state.exportingType = payload
}

const setPlanBenefit = (state, payload) => {
  state.planBenefit = payload
}

export default {
  setPresentation,
  updatePresentation,
  unsetPresentation,
  setIsCreatingNewPresentation,
  toggleNotificationPanel,
  resetNotificationUnread,
  setMorePresentationsLoading,
  setQRCodeVisible,
  setIsOpeningPrivateFeedback,
  setPresentFromBeginning,
  addSlides,
  setExportingType,
  setPlanBenefit,
}
